class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[name="quantity"]');
    this.lineItemCard = this.closest('.line-item-card');

    if (!this.input || !this.lineItemCard) return;

    this.initializeQuantity();

    this.input.addEventListener('change', () => this.handleQuantityChange());

    // Keep input in sync when reservedProducts changes in sessionStorage
    window.addEventListener('storage', ({ key }) => {
      if (key !== 'reservedProducts') return;
      this.initializeQuantity();
    });
  }

  initializeQuantity() {
    const { lineItemId: productId } = this.lineItemCard.dataset;
    const reservedProducts = JSON.parse(sessionStorage.getItem('reservedProducts') || '[]');
    const { quantity } = reservedProducts.find(({ id }) => id === productId) || {};

    if (!quantity) return;
    this.input.value = quantity;
  }

  handleQuantityChange() {
    const { value: quantity } = this.input;
    const { lineItemId: productId } = this.lineItemCard.dataset;

    publish('quantity-changed', { productId, quantity });
  }
}

customElements.define('quantity-input', QuantityInput);
